module.exports = __webpack_public_path__ + "img/AllAlong-Cover.d5ec13c9.jpg";